export default {
  async setItem(key, value) {
    const json = JSON.stringify(value);
    sessionStorage.setItem(key, json);
    localStorage.setItem(key, json);
  },

  async getItem(key, defaultValue) {
    const value = sessionStorage.getItem(key) || localStorage.getItem(key);
    return value ? JSON.parse(value) : (defaultValue ?? null);
  },

  async removeItem(key) {
    sessionStorage.removeItem(key);
    localStorage.removeItem(key);
  },
};
